import { render, staticRenderFns } from "./harmful.vue?vue&type=template&id=92d6201a&scoped=true"
import script from "./harmful.vue?vue&type=script&lang=js"
export * from "./harmful.vue?vue&type=script&lang=js"
import style0 from "./harmful.vue?vue&type=style&index=0&id=92d6201a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d6201a",
  null
  
)

export default component.exports